module.exports = __webpack_public_path__ + "static/media/mindset.b020a7c4.png";